"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfFeatureItemDto = instanceOfFeatureItemDto;
exports.FeatureItemDtoFromJSON = FeatureItemDtoFromJSON;
exports.FeatureItemDtoFromJSONTyped = FeatureItemDtoFromJSONTyped;
exports.FeatureItemDtoToJSON = FeatureItemDtoToJSON;
exports.FeatureItemDtoToJSONTyped = FeatureItemDtoToJSONTyped;
var FeatureValueDto_1 = require("./FeatureValueDto");
/**
 * Check if a given object implements the FeatureItemDto interface.
 */
function instanceOfFeatureItemDto(value) {
    if (!('code' in value) || value['code'] === undefined)
        return false;
    if (!('displayName' in value) || value['displayName'] === undefined)
        return false;
    if (!('category' in value) || value['category'] === undefined)
        return false;
    if (!('sortOrder' in value) || value['sortOrder'] === undefined)
        return false;
    if (!('value' in value) || value['value'] === undefined)
        return false;
    return true;
}
function FeatureItemDtoFromJSON(json) {
    return FeatureItemDtoFromJSONTyped(json, false);
}
function FeatureItemDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'code': json['code'],
        'displayName': json['displayName'],
        'description': json['description'] == null ? undefined : json['description'],
        'category': json['category'],
        'icon': json['icon'] == null ? undefined : json['icon'],
        'sortOrder': json['sortOrder'],
        'value': (0, FeatureValueDto_1.FeatureValueDtoFromJSON)(json['value']),
    };
}
function FeatureItemDtoToJSON(json) {
    return FeatureItemDtoToJSONTyped(json, false);
}
function FeatureItemDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'code': value['code'],
        'displayName': value['displayName'],
        'description': value['description'],
        'category': value['category'],
        'icon': value['icon'],
        'sortOrder': value['sortOrder'],
        'value': (0, FeatureValueDto_1.FeatureValueDtoToJSON)(value['value']),
    };
}
